import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { EigentuemerService } from '../../api';

export const getEigentuemer = () => async (dispatch: Dispatch<ReduxAction>) => {
  new EigentuemerService().getEigentuemer().then(result => {
    dispatch({
      type: ActionTypes.GET_EIGENTUEMER,
      payload: result.data,
    });
  });
};
